import { render, staticRenderFns } from "./VoiceChatRoom.vue?vue&type=template&id=bc3d8318&scoped=true"
import script from "./VoiceChatRoom.vue?vue&type=script&lang=js"
export * from "./VoiceChatRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3d8318",
  null
  
)

export default component.exports